import {useMutation, useQuery} from '@tanstack/react-query';

import {RQ_CATEGORY_REGISTER, RQ_DELETE_CATEGORY, RQ_GET_CATEGORY_API, RQ_UPDATE_CATEGORY} from './constants/ProductCategoryConstant';
import {rqCreateRequest} from './rqHttpUtils';

export const RQGetCategoryAPI = token => {
  return useQuery({
    queryKey: ['rq_get_all_category', token],
    queryFn: async () => {
      if (!token) {return [];}
      const response = await rqCreateRequest(RQ_GET_CATEGORY_API, null, token);
      return response || [];
    },
    enabled:              !!token,
    refetchOnWindowFocus: false,
    retry:                1,
  });
};

export const RQCategoryRegistrationAPI = (options = {}) => {
  return useMutation({
    mutationKey: ['rq_register_category'],
    mutationFn: async ({token, formData}) => {
      return rqCreateRequest(
        RQ_CATEGORY_REGISTER,
        formData,
        token,
        null,
      );
    },
    ...options,
  });
};

export const RQUpdateCategoryAPI = (options = {}) => {
  return useMutation({
    mutationKey: ['rq_update_category'],
    mutationFn: async ({token, formData, id}) => {
      const url = RQ_UPDATE_CATEGORY.url.replace('<%= id %>', id);
      try {
        const response = await rqCreateRequest(
          {...RQ_UPDATE_CATEGORY, url},
          formData,
          token,
          null,
        );
        return response;
      } catch (error) {
        console.error('Error updating category:', error);
        throw error;
      }
    },
    ...options,
  });
};

export const RQDeleteCategoryAPI = (options = {}) => {
  return useMutation({
    mutationKey: ['rq_delete_category'],
    mutationFn: async ({token, id}) => {
      if (!token) {throw new Error('Token is required');}
      const url = RQ_DELETE_CATEGORY.url.replace('<%= id %>', id);
      try {
        const response = await rqCreateRequest(
          {...RQ_DELETE_CATEGORY, url},
          null, 
          token,
          null, 
          null, 
        );

        return response;
      } catch (error) {
        console.error('Error deleting category:', error);
        throw error;
      }
    },
    ...options,
  });
};
